import React, { VFC } from 'react';
import { css } from '@emotion/css';
import p2Img1 from '../../assets/images/p2-1.png';
import p2Img2 from '../../assets/images/p2-2.png';
import p2Img3 from '../../assets/images/p2-3.png';
import p2Img4 from '../../assets/images/p2-4.png';

type Item = { image: string; title: string; desc: string };

const items: Item[] = [
  {
    image: p2Img1,
    title: '深度业务集成',
    desc: '无缝嵌入现有ERP、CRM与OA系统。AI不再是孤岛。',
  },
  {
    image: p2Img2,
    title: '私有知识赋能',
    desc: '基于私有文档、SOP与数据库，融合多模态数据，构建‘企业大脑’。',
  },
  {
    image: p2Img3,
    title: '智能流程重塑',
    desc: '垂类业务重塑核心工作流，实现端到端的智能化提效。',
  },
  {
    image: p2Img4,
    title: '安全合规部署',
    desc: '私有化或专有云部署。您的核心数据100%不出域，金融级的安全合规保障。',
  },
];

export const P2Section: VFC = () => {
  return (
    <section className={styles.wrapper} aria-label="P2">
      <h2 className={styles.sectionTitle}>构建 AI 核心竞争力</h2>
      {/* <p className={styles.subTitle}>
        这是副标题文案这是副标题文案这是副标题文案这是副标题文案
      </p> */}
      <ul className={styles.grid}>
        {items.map((it, idx) => (
          <li key={idx} className={styles.card}>
            <div className={styles.cardInner}>
              <img src={it.image} alt={it.title} className={styles.icon} />
              <div className={styles.texts}>
                <h3 className={styles.title}>{it.title}</h3>
                <p className={styles.desc}>{it.desc}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

const styles = {
  wrapper: css`
    pointer-events: none;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6vh 0;
    width: min(1400px, 92vw);
    color: #fff;
  `,
  sectionTitle: css`
    pointer-events: auto;
    text-align: center;
    font-size: 42px;
    font-weight: 800;
    margin: 0 0 5px 0;
    opacity: 0;
    transform: translate3d(30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    
    @media (max-width: 768px) {
      font-size: 32px;
    }
  `,
  subTitle: css`
    pointer-events: auto;
    text-align: center;
    margin: 0 auto;
    max-width: 760px;
    font-size: 20px;
    opacity: 0;
    transform: translate3d(-30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 0.9;
      transform: translate3d(0, 0, 0);
    }
  `,
  grid: css`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
    margin-top: 60px;
    padding: 0;
    list-style: none;
    opacity: 0;
    transition: opacity 0.7s ease 0.1s;

    .reveal-visible & {
      opacity: 1;
    }

    @media (max-width: 860px) {
      grid-template-columns: 1fr;
    }
  `,
  card: css`
    pointer-events: auto;
  `,
  cardInner: css`
    height: 212px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(6px);
    color: #fff;
    padding: 40px;
    transition: transform 0.25s ease, border-color 0.25s ease, background 0.25s ease,
      box-shadow 0.25s ease;
    will-change: transform;
    transform: translateZ(0);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    &:hover {
      transform: translateY(-4px);
      border-color: rgba(255, 255, 255, 0.22);
      background: rgba(0, 0, 0, 0.35);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);
    }
  `,
  icon: css`
    width: 40px;
    height: 40px;
    display: block;
    margin-bottom: 26px;
    object-fit: contain;
  `,
  texts: css`
    flex: 1;
  `,
  title: css`
    font-size: 20px;
    font-weight: 700;
    margin: 0;
  `,
  desc: css`
    font-size: 16px;
    margin: 6px 0 0 0;
    opacity: 0.86;
  `,
};
